const options = {
	enableHighAccuracy: true,
	timeout: 15000,
	maximumAge: 60000,
};

function deg2rad(deg) {
	return deg * (Math.PI / 180);
}

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
	const R = 6371; // Radius of the earth in km
	const dLat = deg2rad(lat2 - lat1); // deg2rad below
	const dLon = deg2rad(lon2 - lon1);
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	return R * c; // Distance in km
};

export const getLocation = () => {
	return new Promise((resolve, reject) => {
		if (!global.navigator.geolocation) {
			//ClientTracker.setInfoMessage('GeolocationHelper: Geolocation is not supported');
			reject('GeolocationHelper: Geolocation is not supported');
			return;
		}

		navigator.geolocation.getCurrentPosition(resolve, reject, options);
	});
};
